import React from 'react';
import { StringHelpers, SystemText } from '@salesperformanceint/e4shared';
import Panel from 'components/general/panel';
import FocusTile from 'views/user/1-2-1s/components/performanceDashboard/components/focusTile';

export const SharedObjectives = ({ focus, data, setShow }) => {
    if (!data || data.length === 0) return null;
    const total = data.length;

    const message = SystemText(`Home/Widgets/WhatsHappening/SharedObjectives/${total === 1 ? 'One' : 'Some'}`, total);

    // const message = `${total} ${StringHelpers.pluralise('objective', total)} ${
    //     total === 1 ? 'has' : 'have'
    // } been shared with you`;

    const url = total === 1 ? `/objectives/${data[0].profile_Id}/objective/${data[0].id}` : '';

    if (focus) {
        return (
            <FocusTile
                tileType="objective"
                colour="green"
                icon="fa-calendar"
                message={message}
                url={url}
                setShow={setShow}
            />
        );
    }

    return <Panel colour="information" icon="share-from-square" message={message} url={url} setShow={setShow} />;
};

export default SharedObjectives;
